module.exports = __webpack_public_path__ + "static/img/kffw@2x.3a6c684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kffw@2x.png
// module id = FlSR
// module chunks = 2